<template lang="pug">
div
    .text-center
        .col-sm-12.text-center.p-t-1
            small.block(v-if="outlet.company_details") {{ outlet.company_details.name }}
            small.block {{ outlet.name }}
            small.block {{ outlet.address }}
            small.block {{ receiptDateFormatModal(pgsql_transaction.receipt_date, null) }}
            small.block(v-if="outlet.phone_no") Phone: {{ outlet.phone_no }}
            small.block Site: {{ outlet.code }}
            small.block(v-if="stan") STAN: {{ stan }}
            small.block(v-if="approvalCode") Approval Code: {{ approvalCode }}
            small.block(v-if="referenceNo") Reference No: {{ referenceNo }}
            small.block(v-if="ghlPaymentReferenceNo") Payment Ref No: {{ ghlPaymentReferenceNo }}
            small.block(v-if="ghlRefundReferenceNo") Refund Ref No: {{ ghlRefundReferenceNo }}
            small.block(v-if="ghlMerchantId") MID: {{ ghlMerchantId }}
            small.block(v-if="ghlTerminalId") TID: {{ ghlTerminalId }}

    .row(v-if="!pgsql_transaction.drawer_session && !pgsql_transaction.forecourt_attendant")
        .col-sm-12
            .row
                .col-xs-4
                    small.pull-left Invoice #
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt) }}

    .row(v-else-if="pgsql_transaction.forecourt_attendant && pgsql_transaction.forecourt_attendant.id")
        .col-sm-12
            .row
                .col-xs-4
                    small.pull-left Invoice #
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt) }}

        .col-sm-12
            .row
                .col-xs-4
                    small.pull-left Attendant
                    br
                    h5.pull-left {{ pgsql_transaction.forecourt_attendant.staff_name }}

                .col-xs-4
                    small.pull-left Attendant Card No.
                    br
                    h5.pull-left {{ pgsql_transaction.forecourt_attendant.card_pan }}

                .col-xs-4
                    small.pull-left Attendant Till #
                    br
                    h5.pull-left {{ pgsql_transaction.forecourt_attendant.sequence_number }}


    .row(v-else)
        .col-sm-12
            .row
                .col-xs-4.text-break
                    small.pull-left POS
                    br
                    small.pull-left {{ pgsql_transaction.drawer_session.device_name }}

                .col-xs-4
                    small.pull-left Staff
                    br
                    small.pull-left {{ pgsql_transaction.drawer_session.staff_name }}

                .col-xs-4
                    small.pull-left Invoice #
                    br
                    small.pull-left {{ receiptNumberFormat(receipt) }}

            .row
                .col-xs-4
                    small.pull-left Shift #
                    br
                    small.pull-left {{ pgsql_transaction.drawer_session.sequence_number }}
        

</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';
import Unleash from '@js/plugins/unleash';

export default {
    mixins: [receiptMixin],
    computed: {
        ...mapGetters('transactionPostgres', [
            'pgsql_transaction',
            'outlet',
            'receipt',
            'approvalCode',
            'referenceNo',
            'stan',
            'ghlPaymentReferenceNo',
            'ghlRefundReferenceNo',
            'ghlMerchantId',
            'ghlTerminalId',
        ]),

        logo() {
            return Auth.franchise().logo;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt-ph/details.vue